import { render, staticRenderFns } from "./ReCRUDFields.vue?vue&type=template&id=a479f952&scoped=true"
import script from "./ReCRUDFields.vue?vue&type=script&lang=js"
export * from "./ReCRUDFields.vue?vue&type=script&lang=js"
import style0 from "./ReCRUDFields.vue?vue&type=style&index=0&id=a479f952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a479f952",
  null
  
)

export default component.exports